module.exports = __webpack_public_path__ + "static/media/ottawa.1e5fea31.jpg";